// extracted by mini-css-extract-plugin
module.exports = {"Container":"Destination_Container__15fE0","Title":"Destination_Title__2mOTa","Destination":"Destination_Destination__2RZ40"};